import { render, staticRenderFns } from "./CbsSubobject.vue?vue&type=template&id=5a382ad8&scoped=true"
import script from "./CbsSubobject.vue?vue&type=script&lang=js"
export * from "./CbsSubobject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a382ad8",
  null
  
)

export default component.exports